"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var styles = __importStar(require("./StyleLibrary.css"));
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
var StyleButton_css_1 = require("Project/BlockNew/Menu/Settings/StyleButton/StyleButton.css");
var BlockStyleStore_1 = require("Project/Stores/BlockStyleStore");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var SelectorUtils_1 = require("@CommonFrontend/Utils/SelectorUtils");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var CustomizeStyle_1 = require("./CustomizeStyle/CustomizeStyle");
var BlockStyleVarsCompiler_1 = require("@CommonFrontend/Styles/BlockStyles/BlockStyleVarsCompiler");
var RegistryElement_1 = require("Project/QwilrEditor/RegistryElement/RegistryElement");
var Heading1_1 = require("Project/QwilrEditor/WidgetRegistry/Widgets/Heading1");
var widgetStyle_1 = require("@CommonFrontend/Utils/widgetStyle");
var FilterableColorProvider_1 = require("Project/QwilrEditor/Styling/FilterableColorProvider");
var Paragraph_1 = require("Project/QwilrEditor/WidgetRegistry/Widgets/Paragraph");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var StylePreview = function (_a) {
    var style = _a.style;
    if ((0, BlockStyleTypes_1.isSourceStyle)(style)) {
        throw new Error("Style preview not supported for source block");
    }
    var colors = (0, inversify_react_1.useInjection)("brandStore").allColors;
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    var heading1StylableConfig = Heading1_1.heading1Config.traits.styleable;
    var paragraphStylableConfig = Paragraph_1.paragraphConfig.traits.styleable;
    (0, tiny_invariant_1.default)(heading1StylableConfig != undefined, "heading1Config should have a styleable trait");
    (0, tiny_invariant_1.default)(paragraphStylableConfig != undefined, "paragraphConfig should have a styleable trait");
    var styleVars = (0, BlockStyleVarsCompiler_1.compileBlockStyleVars)({ style: style }, colors);
    var heading1RawStyles = (0, widgetStyle_1.widgetStyle)({
        blockStyle: style.h1,
        overrides: null,
        colorProvider: colorProvider,
        styleableConfig: heading1StylableConfig,
    });
    var h1StyleVars = (0, RegistryElement_1.styleToVEVars)(heading1RawStyles, heading1StylableConfig).style;
    var pRawStyles = (0, widgetStyle_1.widgetStyle)({
        blockStyle: style.p,
        overrides: null,
        colorProvider: colorProvider,
        styleableConfig: paragraphStylableConfig,
    });
    var pStyleVars = (0, RegistryElement_1.styleToVEVars)(pRawStyles, paragraphStylableConfig).style;
    return (react_1.default.createElement("div", { className: styles.stylePreview, style: __assign(__assign(__assign({}, styleVars), h1StyleVars), pStyleVars) },
        react_1.default.createElement("div", { className: styles.stylePreviewImage }),
        react_1.default.createElement("div", { className: styles.stylePreviewTint }),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.stylePreviewTextCard, direction: "vertical", align: "start", justify: "center", gap: "l" },
            react_1.default.createElement("h1", { className: styles.stylePreviewTitle }, "Block Heading"),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "s" },
                react_1.default.createElement("p", { className: styles.stylePreviewBody }, "Prepared for Pivotal Marketing \u2014 by ACME."),
                react_1.default.createElement("p", { className: styles.stylePreviewBody }, "saniyakim@acme.com | acme.com ")))));
};
var StyleOptionMenu = (0, mobx_react_1.observer)(function (_a) {
    var style = _a.style, stylesChangedFromLibrary = _a.stylesChangedFromLibrary, allowPublish = _a.allowPublish, allowRevert = _a.allowRevert, applyStyleToBlock = _a.applyStyleToBlock, isStyleApplied = _a.isStyleApplied;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var styleModalService = (0, inversify_react_1.useInjection)("styleModalService");
    var savedStyleService = (0, inversify_react_1.useInjection)("savedStyleService");
    var blockStyleStore = blockStore.blockStyleStore;
    var handlePublishToLibrary = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updateType;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isStyleApplied)
                        return [2];
                    return [4, styleModalService.showUpdateModal(blockStyleStore.model)];
                case 1:
                    updateType = _a.sent();
                    if (!updateType)
                        return [2];
                    telemetry.trackOnly("Block Styles Changes Saved", {
                        block_styles_changes_saved_type: "current_project_and_new",
                    });
                    return [2];
            }
        });
    }); };
    var handleRevertChanges = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isStyleApplied)
                        return [2];
                    return [4, styleModalService.showRevertModal(blockStyleStore.model)];
                case 1:
                    confirmed = _a.sent();
                    if (!confirmed)
                        return [2];
                    applyStyleToBlock();
                    telemetry.trackOnly("Block Styles Changes Reverted");
                    return [2];
            }
        });
    }); };
    var handleClone = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, styleModalService.showSaveModal(style)];
                case 1:
                    _a.sent();
                    telemetry.trackOnly("Block Styles Cloned");
                    return [2];
            }
        });
    }); };
    var handleRename = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, styleModalService.showRenameModal(style)];
                case 1:
                    _a.sent();
                    telemetry.trackOnly("Block Styles Renamed");
                    return [2];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, styleModalService.showDeleteModal(style)];
                case 1:
                    _a.sent();
                    savedStyleService.trackDeleteStyle(blockStore.blockType);
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, className: "nested-portal", position: kaleidoscope_1.PopoverPosition.Bottom, padding: "none", size: kaleidoscope_1.PopoverSize.Auto, button: function (buttonProps) { return (react_1.default.createElement(react_1.default.Fragment, null,
            stylesChangedFromLibrary && react_1.default.createElement(Indicator, { className: styles.buttonIndicator }),
            react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { isRound: true, type: kaleidoscope_1.ButtonType.Tertiary, className: styles.optionsMenuButton, icon: react_1.default.createElement(icons_1.OptionsHorizontal, null) })))); } },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "xs", padding: "xs" },
            react_1.default.createElement(kaleidoscope_1.MenuItem, { size: "s", startElement: react_1.default.createElement(icons_1.LibraryAdd, null), disabled: !allowPublish, tooltip: allowPublish ? undefined : { content: "No changes to publish", wrapTarget: true }, onClick: handlePublishToLibrary, role: "menuitem", "aria-haspopup": "dialog" },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, " Publish to library")),
            react_1.default.createElement(kaleidoscope_1.MenuItem, { size: "s", startElement: react_1.default.createElement(icons_1.Reset, null), disabled: !allowRevert, tooltip: allowRevert ? undefined : { content: "No changes made", wrapTarget: true }, onClick: handleRevertChanges, role: "menuitem" },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, " Revert changes")),
            react_1.default.createElement(kaleidoscope_1.MenuItem, { size: "s", startElement: react_1.default.createElement(icons_1.Copy, null), onClick: handleClone, role: "menuitem" },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, " Clone")),
            react_1.default.createElement(kaleidoscope_1.MenuItem, { size: "s", startElement: react_1.default.createElement(icons_1.Edit, null), disabled: style.name === "Default Style", tooltip: style.name !== "Default Style" ? undefined : { content: "Cannot rename default style", wrapTarget: true }, onClick: handleRename, role: "menuitem", "aria-haspopup": "dialog" },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, " Rename"))),
        react_1.default.createElement(kaleidoscope_1.Separator, null),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "xs", padding: "xs" },
            react_1.default.createElement(kaleidoscope_1.MenuItem, { size: "s", startElement: react_1.default.createElement(icons_1.Delete, null), destructive: true, disabled: style.name === "Default Style", tooltip: style.name !== "Default Style" ? undefined : { content: "Cannot delete default style", wrapTarget: true }, onClick: handleDelete, role: "menuitem", "aria-haspopup": "dialog" },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, " Delete")))));
});
var Indicator = function (_a) {
    var className = _a.className;
    return react_1.default.createElement("div", { className: (0, classnames_1.default)(className, styles.indicator) });
};
var ConfirmationModal = function (_a) {
    var show = _a.show, isCurrentlySelectedStyle = _a.isCurrentlySelectedStyle, onClick = _a.onClick, children = _a.children;
    var _b = __read((0, react_1.useState)(false), 2), isConfirmationPopoverOpen = _b[0], setIsConfirmationPopoverOpen = _b[1];
    (0, react_1.useEffect)(function () {
        var panelScroll = document.querySelector("".concat((0, SelectorUtils_1.toSelector)(styles.panel), " .popover__panel-scroll"));
        if (isConfirmationPopoverOpen && panelScroll) {
            var handleScroll_1 = function () {
                setIsConfirmationPopoverOpen(false);
            };
            panelScroll.addEventListener("scroll", handleScroll_1);
            return function () {
                panelScroll.removeEventListener("scroll", handleScroll_1);
            };
        }
        return;
    }, [isConfirmationPopoverOpen]);
    return (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, size: kaleidoscope_1.PopoverSize.Small, className: "nested-portal", isOpen: show ? isConfirmationPopoverOpen : false, onChange: function (open) {
            setIsConfirmationPopoverOpen(open);
        }, button: function (_a) {
            var ref = _a.ref, buttonProps = __rest(_a, ["ref"]);
            return children(__assign(__assign({}, buttonProps), { ref: ref, onClick: show ? buttonProps.onClick : onClick }));
        } },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs" },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true },
                    isCurrentlySelectedStyle ? "Reset" : "Use",
                    " this style?"),
                react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, lineHeight: "compact", size: "s" }, "You have unsaved style changes in this block. If you continue, those changes will be lost.")),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
                        setIsConfirmationPopoverOpen(false);
                    } }, "Cancel"),
                react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: true, onClick: onClick }, "Continue")))));
};
var StyleItem = (0, mobx_react_1.observer)(function (_a) {
    var style = _a.style, isStyleApplied = _a.isStyleApplied, setAppliedStyleId = _a.setAppliedStyleId, hasPermissionToEdit = _a.hasPermissionToEdit, appliedStyleRef = _a.appliedStyleRef, currentBlockHasUnsavedStyles = _a.currentBlockHasUnsavedStyles;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var savedStyleService = (0, inversify_react_1.useInjection)("savedStyleService");
    var blockStyleStore = blockStore.blockStyleStore;
    var blockStyleStoreModel = (0, BlockStyleStore_1.getNonSourceBlockStyle)(blockStore.blockStyleStore);
    var applyStyleToBlock = function () {
        savedStyleService.cloneSavedStyleToBlock(blockStyleStore, style);
        setAppliedStyleId(style._id);
        telemetry.trackOnly("Block Styles Applied", {
            block_styles_applied_type: blockStore.blockType,
        }, {
            blockIntercom: true,
        });
    };
    var isCurrentlySelectedStyle = blockStyleStoreModel.clonedFrom === style._id;
    var showConfirmationDialog = currentBlockHasUnsavedStyles;
    var stylesChangedFromLibrary = false;
    var allowPublish = isCurrentlySelectedStyle;
    var allowRevert = isCurrentlySelectedStyle;
    return (react_1.default.createElement(kaleidoscope_1.ButtonCard, { onClick: function () { return void 0; }, className: styles.card({ selected: isStyleApplied, stylesChangedFromLibrary: stylesChangedFromLibrary }), ref: appliedStyleRef },
        react_1.default.createElement(ConfirmationModal, { show: showConfirmationDialog, isCurrentlySelectedStyle: isCurrentlySelectedStyle, onClick: applyStyleToBlock }, function (buttonProps) { return (react_1.default.createElement("div", __assign({}, buttonProps, { className: styles.styleItem }),
            react_1.default.createElement(StylePreview, { style: style }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(tokens_1.darkTheme, styles.cardOverlay) },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, style.name)))); }),
        stylesChangedFromLibrary && react_1.default.createElement(Indicator, { className: styles.cardIndicator }),
        hasPermissionToEdit && (react_1.default.createElement(StyleOptionMenu, { style: style, stylesChangedFromLibrary: stylesChangedFromLibrary, allowPublish: allowPublish, allowRevert: allowRevert, applyStyleToBlock: applyStyleToBlock, isStyleApplied: isStyleApplied })),
        isStyleApplied && (react_1.default.createElement("div", { className: styles.blueTickIcon },
            react_1.default.createElement(icons_1.Tick, null)))));
});
var StyleLibraryV2Layer = function (_a) {
    var isSavedBlock = _a.isSavedBlock, children = _a.children;
    if (isSavedBlock) {
        return react_1.default.createElement(kaleidoscope_1.AngularOverlayProvider, null, children);
    }
    return react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.contentSidebarZIndex }, function () { return react_1.default.createElement(react_1.default.Fragment, null, children); });
};
var StyleTiles = (0, mobx_react_1.observer)(function (_a) {
    var blockStyleStoreModel = _a.blockStyleStoreModel, currentBlockHasUnsavedStyles = _a.currentBlockHasUnsavedStyles, filteredStyles = _a.filteredStyles, onCustomizeStyleClick = _a.onCustomizeStyleClick;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var savedStyleService = (0, inversify_react_1.useInjection)("savedStyleService");
    var styleModalService = (0, inversify_react_1.useInjection)("styleModalService");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var trackCreateStyle = savedStyleService.trackCreateStyle;
    var _b = __read((0, react_1.useState)(blockStyleStoreModel.clonedFrom || ""), 2), appliedStyleId = _b[0], setAppliedStyleId = _b[1];
    var appliedStyleRef = (0, react_1.useRef)(null);
    var handleAddStyle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var clonedFrom, style;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clonedFrom = blockStyleStoreModel.clonedFrom;
                    if (!clonedFrom)
                        return [2];
                    return [4, styleModalService.showSaveModal(blockStyleStoreModel)];
                case 1:
                    style = _a.sent();
                    if (style === false || style === null)
                        return [2];
                    blockStyleStoreModel.clonedFrom = style._id;
                    setAppliedStyleId(style._id);
                    trackCreateStyle(style, blockStore.blockType, clonedFrom);
                    return [2];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        telemetry.trackOnly("Block Styles Viewed", {}, {
            blockIntercom: true,
        });
        if (appliedStyleRef.current) {
            setTimeout(function () {
                var _a;
                (_a = appliedStyleRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                });
            }, 200);
        }
    }, []);
    var hasStyleEditPermission = stylePermissionStore.allowStyle(Types_1.StyleAccessType.StyleLibrary);
    var hasCustomizeStylePermission = !stylePermissionStore.isStylePermissionEnabled || stylePermissionStore.allowStyleShortcut;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.scrollContainer },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween", align: "center", paddingRight: "m", paddingTop: "m", paddingLeft: "l" },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m" }, "Style library"),
                hasStyleEditPermission && (react_1.default.createElement(kaleidoscope_1.Tooltip, { autoStack: true, content: "Create new style" },
                    react_1.default.createElement(kaleidoscope_1.IconButton, { "aria-label": "Add style", icon: react_1.default.createElement(icons_1.Add, { color: "default" }), onClick: handleAddStyle, buttonState: kaleidoscope_1.ButtonState.Idle })))),
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "m", paddingLeft: "l", paddingRight: "l", direction: "vertical" },
                react_1.default.createElement(FilterableColorProvider_1.FilterableColorContextProvider, { brandStore: brandStore, blockStore: blockStore },
                    react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.cardsContainer) }, !!filteredStyles.length &&
                        filteredStyles.map(function (style) { return (react_1.default.createElement(StyleItem, { key: style._id, style: style, isStyleApplied: appliedStyleId === style._id, appliedStyleRef: appliedStyleId === style._id ? appliedStyleRef : undefined, setAppliedStyleId: setAppliedStyleId, hasPermissionToEdit: hasStyleEditPermission, currentBlockHasUnsavedStyles: currentBlockHasUnsavedStyles })); }))))),
        usingFeature(FeatureFlag_1.default.NewCustomizeStyleUI) && hasCustomizeStylePermission && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.Separator, null),
            react_1.default.createElement(kaleidoscope_1.Stack, null,
                react_1.default.createElement(kaleidoscope_1.Button, { className: styles.customizeStyleButton, onClick: onCustomizeStyleClick, type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Large, width: "full" },
                    "Customize style",
                    react_1.default.createElement(icons_1.ChevronRight, null)))))));
});
var StyleLibraryV2 = (0, mobx_react_1.observer)(function () {
    var _a;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var isSidebarOpened = (0, inversify_react_1.useInjection)("isSidebarOpened");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var savedStyleService = (0, inversify_react_1.useInjection)("savedStyleService");
    var _b = __read((0, react_1.useState)("library"), 2), currentMenu = _b[0], setCurrentMenu = _b[1];
    (0, react_1.useEffect)(function () {
        savedStyleService.getAllSavedStyles();
    }, [savedStyleService]);
    var blockStyleStoreModel = (0, BlockStyleStore_1.getNonSourceBlockStyle)(blockStore.blockStyleStore);
    var filteredStyles = savedStyleService.getSavedStylesByBlockType(blockStore.blockType);
    var currentlyAppliedStyle = filteredStyles.find(function (style) { return blockStyleStoreModel.clonedFrom === style._id; });
    var currentBlockHasUnsavedStyles = false;
    return (react_1.default.createElement(StyleLibraryV2Layer, { isSavedBlock: blockStore.isSavedBlock },
        react_1.default.createElement(kaleidoscope_1.Popover, { outerMargin: {
                left: isSidebarOpened() ? 360 + 16 : 16,
                top: 16,
                bottom: 16,
                right: 16,
            }, size: kaleidoscope_1.PopoverSize.Auto, caret: true, className: styles.panel, padding: "none", autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { isRound: true, isIconOnly: true, className: StyleButton_css_1.styleLibraryButton, size: kaleidoscope_1.ButtonSize.Small, icon: usingFeature(FeatureFlag_1.default.NewCustomizeStyleUI) ? react_1.default.createElement(icons_1.StylesBrush, null) : react_1.default.createElement(icons_1.StylesLibrary, null), tooltip: {
                    content: "Style library",
                    position: kaleidoscope_1.TooltipPosition.Top,
                } }))); } }, currentMenu === "library" ? (react_1.default.createElement(StyleTiles, { blockStyleStoreModel: blockStyleStoreModel, currentBlockHasUnsavedStyles: currentBlockHasUnsavedStyles, filteredStyles: filteredStyles, onCustomizeStyleClick: function () { return setCurrentMenu("customize"); } })) : (react_1.default.createElement(CustomizeStyle_1.CustomizeStyle, { currentlyAppliedStyleName: (_a = currentlyAppliedStyle === null || currentlyAppliedStyle === void 0 ? void 0 : currentlyAppliedStyle.name) !== null && _a !== void 0 ? _a : "", onBackClick: function () { return setCurrentMenu("library"); } })))));
});
exports.default = StyleLibraryV2;
